import React from "react";
import useRedux from "hooks/useRedux";

import * as actionsGroupList from "./account.duck";
import * as adminActionsList from "../admin/admin.duck";
import * as editorActionsGroupList from "portfolioEntryWizard/portfolioEntry.duck";
import * as shoppingCartGroupList from "../shoppingCart/shoppingCart.duck";

import MyOrders from "./components/MyOrders";
import MyPortfolios from "./components/MyPortfolios";
import MyProfile from "./components/MyProfile";

import Heading from "../home/components/Heading";

import { getUser } from "../helpers/userStorage";

import DatabaseAdmin from "../admin/components/Database";
import UserAdmin from "../admin/components/Users";
import SiteSettings from '../admin/components/SiteSettings'

import { hashHistory } from "browserHistory";

import styled from "styled-components";

const Page = styled.div`
  height: calc(100vh - 85px);
`;

const Row = styled.div`
  display: flex;
  height: 100%;
`;

const Menu = styled.div`
  background-color: #e0e0e0;
  height: 100%;
  width: 200px;
  min-width: 200px;
`;

const Content = styled.div`
  height: 100%;
  // padding: 20px;
  width: 100%;
  overflow: auto;
  // max-width:1000px;
`;

const Main = (props) => {
  const { match } = props;

  const { params } = match;
  const { mode = "Portfolios" } = params;

  const [
    state,
    actions,
    editorActions,
    adminActions,
    shoppingCartActions,
  ] = useRedux(
    actionsGroupList,
    editorActionsGroupList,
    adminActionsList,
    shoppingCartGroupList
  );

  const account = state.account;
  const editorState = state.portfolioEntry;
  const adminState = state.admin;

  var user = getUser();

  if (!user) {
    hashHistory.push("/Home");
  }

  const linkStyle = {
    color: "#3f51b5",
    fontSize: 14,
    marginBottom: 20,
    marginTop: 20,
    cursor: "pointer",
  };

  const linkStyleSelected = {
    ...linkStyle,
    ...{
      fontWeight: "bold",
    },
  };

  return (
    <div>
      <Heading {...props} buttons={[]} />

      <Page>
        <Row>
          <Menu>
            <div style={{ margin: 20 }}>
              <div
                style={mode === "Portfolios" ? linkStyleSelected : linkStyle}
                onClick={() => {
                  hashHistory.push(`/Account/Portfolios`);
                }}
              >
                Your Portfolios
              </div>
              <div
                style={mode === "Orders" ? linkStyleSelected : linkStyle}
                onClick={() => {
                  hashHistory.push(`/Account/Orders`);
                }}
              >
                Your Orders
              </div>
              <div
                style={mode === "Profile" ? linkStyleSelected : linkStyle}
                onClick={() => {
                  hashHistory.push(`/Account/Profile`);
                }}
              >
                Your Account
              </div>
              {user.isAdmin && (
                <div>
                  <div
                    style={{
                      color: "#3f51b5",
                      fontSize: 18,
                      marginBottom: 20,
                      marginTop: 40,
                      fontWeight: "bold",
                    }}
                  >
                    Administration
                  </div>
                  <div style={{ width: 300 }}>
                    <div
                      style={
                        mode === "Database" ? linkStyleSelected : linkStyle
                      }
                      onClick={() => {
                        hashHistory.push(`/Account/Database`);
                      }}
                    >
                      Value Database
                    </div>
                    <div
                      style={mode === "Users" ? linkStyleSelected : linkStyle}
                      onClick={() => {
                        hashHistory.push(`/Account/Users`);
                      }}
                    >
                      Users
                    </div>
                    <div
                      style={
                        mode === "Settings" ? linkStyleSelected : linkStyle
                      }
                      onClick={() => {
                        hashHistory.push(`/Account/Settings`);
                      }}
                    >
                      Site Settings
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Menu>
          <Content>
            <div style={{ maxWidth: 1000, marginTop: 20, marginLeft: 40 }}>
              <div>
                {mode === "Profile" && <MyProfile {...{ account, actions }} />}
                {mode === "Orders" && (
                  <MyOrders
                    {...{ account, actions, editorState, editorActions }}
                  />
                )}
                {mode === "Portfolios" && (
                  <MyPortfolios
                    {...{
                      account,
                      editorState,
                      actions,
                      editorActions,
                      shoppingCartActions,
                    }}
                  />
                )}
                {mode === "Database" && (
                  <DatabaseAdmin {...{ adminState, adminActions }} />
                )}
                {mode === "Users" && (
                  <UserAdmin {...{ adminState, adminActions, editorActions }} />
                )}
                {mode === "Settings" && (
                  <SiteSettings {...{ adminState, adminActions }} />
                )}
              </div>
            </div>
          </Content>
        </Row>
      </Page>
    </div>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/account/Main.js